import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apolloClient } from '@client/api/graphql/client';
import {
  DeleteReplyMutation,
  DeleteReplyMutationVariables,
  DeleteReplyDocument,
  GetCommunityPostDocument,
} from '../../../../generated/graphql';
import { communityQueryKeys } from '../constants';
import toast from 'react-hot-toast';
import { RefetchQueryDescriptor } from '@apollo/client/core/types';

type DeleteReplyResponse = {
  error: string | undefined;
};

/**
 *
 * @param {number} communityId
 * @param {string} postId Reply parent - needed to invalidate its replies
 * @return {UseMutationResult<DeleteReplyResponse, unknown, string, VoidFunction>}
 */
export const useDeleteReplyMutation = (communityId: number, postId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (replyId: string) => {
      return apolloClient.mutate<
        DeleteReplyMutation,
        DeleteReplyMutationVariables
      >({
        mutation: DeleteReplyDocument,
        variables: {
          communityId: communityId,
          replyId,
        },
      });
    },
    {
      onSuccess: () => {
        toast.success('Your post was successfully deleted!');
      },
      onError: (error: Error) => {
        console.error({ error });
        toast.error('Something went wrong');
      },
      onSettled: async () => {
        await queryClient.refetchQueries(
          communityQueryKeys.post(communityId, postId),
        );
      },
    },
  );
};
